import _asyncToGenerator from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import _styled from "styled-components";
import { useState, useCallback, memo } from 'react';
import { useTranslation } from 'next-i18next';
import { useAuth } from '@restworld/feature-authentication';
import { ModalWrapperCloseIcon, openInNewTab, useModal } from '@restworld/utils-common';
import { Button, Paragraph, Title, FormLabelWrapper, TextInput, BaseModal } from '../../';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var JobFavoritePositionButton = /*#__PURE__*/memo(function (_ref) {
  var favoriteClickHandler = _ref.favoriteClickHandler,
      isJobPositionFavorited = _ref.isJobPositionFavorited;

  var _useTranslation = useTranslation('job-position-page'),
      jobPositionTranslate = _useTranslation.t;

  var _useTranslation2 = useTranslation('common'),
      commonTranslate = _useTranslation2.t;

  var _useModal = useModal(),
      show = _useModal.show,
      close = _useModal.close,
      open = _useModal.open;

  var _useAuth = useAuth(),
      isAuthenticated = _useAuth.isAuthenticated;

  var handleClick = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(email) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return favoriteClickHandler(email);

            case 2:
              close();

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [close, favoriteClickHandler]);
  var clickHandler = useCallback(function () {
    open();
    if (isAuthenticated) favoriteClickHandler();
  }, [favoriteClickHandler, isAuthenticated, open]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Button, {
      variant: "borderless",
      icon: !isJobPositionFavorited ? 'BookmarkIcon' : 'BookmarkSolidIcon',
      onClick: clickHandler
    }), /*#__PURE__*/_jsx(BaseModal, {
      open: show,
      onClose: close,
      modalStyles: [{
        "width": "100%",
        "@media (min-width: 768px)": {
          "minWidth": "22rem",
          "maxWidth": "26rem"
        }
      }],
      closeIcon: /*#__PURE__*/_jsx(ModalWrapperCloseIcon, {}),
      showMobileGestures: true,
      title: /*#__PURE__*/_jsx(Title, {
        variant: "h4-large",
        fontWeight: "semibold",
        content: commonTranslate('check_your_email'),
        icon: "BookmarkIcon",
        isCenter: true
      }),
      children: /*#__PURE__*/_jsx(Wrapper, {
        children: isAuthenticated ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Paragraph, {
            variant: "small",
            color: "gray-500",
            content: jobPositionTranslate('job_favourite_email_information')
          }), /*#__PURE__*/_jsx(Paragraph, {
            variant: "small",
            color: "gray-500",
            content: jobPositionTranslate('apply_at_any_time')
          })]
        }) : /*#__PURE__*/_jsx(JobFavoriteInputModal, {
          favoriteClickHandler: handleClick
        })
      })
    })]
  });
});
export default JobFavoritePositionButton;
export var JobFavoriteInputModal = /*#__PURE__*/memo(function (_ref3) {
  var favoriteClickHandler = _ref3.favoriteClickHandler;

  var _useTranslation3 = useTranslation('common'),
      t = _useTranslation3.t;

  var _useState = useState(''),
      email = _useState[0],
      setEmail = _useState[1];

  var formSubmitHandler = useCallback( /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              e.preventDefault();
              _context2.next = 3;
              return favoriteClickHandler(email);

            case 3:
              setEmail('');

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref4.apply(this, arguments);
    };
  }(), [email, favoriteClickHandler]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Paragraph, {
      content: t('input_email_request')
    }), /*#__PURE__*/_jsxs(FormStyled, {
      action: "",
      onSubmit: formSubmitHandler,
      children: [/*#__PURE__*/_jsx(FormLabelWrapper, {
        label: "Email",
        id: "email",
        children: /*#__PURE__*/_jsx(TextInput, {
          id: "email",
          onChange: function onChange(value) {
            return setEmail(value.trim());
          },
          type: "email",
          placeholder: "sam@example.com",
          required: true,
          value: email
        })
      }), /*#__PURE__*/_jsx(Button, {
        fullwidth: true,
        type: "submit",
        title: t('submit_location')
      })]
    }), /*#__PURE__*/_jsxs(LoginRedirect, {
      children: [/*#__PURE__*/_jsx(Title, {
        textColor: "gray",
        content: t('have_an_account_already'),
        fontWeight: "light"
      }), /*#__PURE__*/_jsx(Button, {
        title: "Log in",
        variant: "ghost",
        onClick: function onClick() {
          return openInNewTab("/login?redirectTo=".concat(encodeURIComponent(window.location.pathname)));
        }
      })]
    })]
  });
});

var Wrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "job-favorite-position-modal__Wrapper",
  componentId: "sc-1ay9mze-0"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "1rem"
});

var LoginRedirect = /*#__PURE__*/_styled.span.withConfig({
  displayName: "job-favorite-position-modal__LoginRedirect",
  componentId: "sc-1ay9mze-1"
})({
  "display": "flex",
  "gap": "0.25rem",
  "alignSelf": "center"
});

var FormStyled = /*#__PURE__*/_styled.form.withConfig({
  displayName: "job-favorite-position-modal__FormStyled",
  componentId: "sc-1ay9mze-2"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "1rem"
});